<template>
    <div v-if="loaded">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUnidade"
                            :options="form.unidades"
                            @change="loadFrom('unidade')"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableInfraestrutura"
                            :options="form.infraestruturas"
                            @change="loadFrom('infraestrutura')"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableOcupacao"
                            :options="form.ocupacoes"
                            @change="loadFrom('ocupacao')"
                            default-option-text="Todas"
                            label="CBO"
                            show-default-option
                            text-field="descricao"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableEspecialidade"
                            :options="form.especialidades"
                            @change="loadFrom('especialidade')"
                            default-option-text="Todas"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUsuario"
                            :options="form.usuarios"
                            @change="loadFrom('usuario')"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            :disabled="disableProcedimento"
                            :options="form.procedimentos"
                            default-option-text="Todos"
                            label="Procedimentos"
                            show-default-option
                            text-field="descricao"
                            v-model="model.procedimentoCodigo"
                            value-field="codigo"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-button
                    :disabled="itens.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="columns"
                :foot-clone="itens.length > 0"
                :items="itens"
                no-footer-sorting
            >
                <template #cell(usuarioNome)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #foot(usuarioNome)>
                    <span></span>
                </template>

                <template #foot(procedimentoDescricao)>
                    <span></span>
                </template>

                <template #foot(quantidade)>
                    <span>{{ getSafely(() => totalizadores.quantidade, 0) }}</span>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, formats, error, data, object, stringCase, file } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                periodo: { required: true },
            }
        },
        disableUnidade() {

            return !this.isPeriodoSelecionado
        },
        disableInfraestrutura() {

            return !this.isPeriodoSelecionado
                || this.model.unidadeId === null
        },
        disableOcupacao() {

            return !this.isPeriodoSelecionado
        },
        disableEspecialidade() {

            return !this.isPeriodoSelecionado
                || this.model.ocupacaoId === null
        },
        disableUsuario() {

            return !this.isPeriodoSelecionado
        },
        disableProcedimento() {

            return !this.isPeriodoSelecionado
        },
        isPeriodoSelecionado() {

            return this.model !== null
                && (this.model.periodo.start instanceof Date)
                && (this.model.periodo.end instanceof Date)
        },
    },
    created() {

        this.repositories = {
            relatorioQuantitativoProcedimento: this.getConectaSusRepository('ambulatorio.relatorioQuantitativoProcedimento'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            model: null,
            initials: {
                form: null,
                model: null,
            },
            columns: [
                { key: 'usuarioNome', label: 'Profissional', sortable: true },
                { key: 'procedimentoDescricao', label: 'Procedimento', sortable: true },
                { key: 'quantidade', label: 'Quantidade', class: 'col-min text-center' },
            ],
            itens: [],
            totalizadores: null,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.relatorioQuantitativoProcedimento.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.initials.form = this.clone(data.form)
                    this.initials.model = this.clone(data.model)

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.$watch('model.periodo', {
                deep: true,
                handler(periodo) {

                    if (periodo.start === null || periodo.end === null) {

                        this.resetAfterPeriodo()
                    }
                    else {

                        this.loadFrom('periodo')
                    }
                }
            })
        },
        loadFrom(field) {

            this.clearFrom(field)

            this.setLoading()

            this.repositories.relatorioQuantitativoProcedimento.list({ ...this.prepareData(), load_from: this.camelToSnake(field) })
                .then(({ data }) => {

                    if ('form' in data) {

                        Object.keys(data.form).forEach(key => this.$set(this.form, key, data.form[key]))
                    }

                    Object.keys(data.model).forEach(key => this.$set(this.model, key, data.model[key]))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearFrom(field) {

            if (field == 'periodo') {

                return
            }

            field = field === 'procedimento' ? `${field}Codigo` : `${field}Id`

            const fields = [
                'unidadeId',
                'infraestruturaId',
                'ocupacaoId',
                'especialidadeId',
                'usuarioId',
                'procedimentoCodigo',
            ]

            fields.slice(fields.indexOf(field) + 1, fields.length)
                .forEach(key => this.$set(this.model, key, null))
        },
        search() {

            this.setLoading()

            this.repositories.relatorioQuantitativoProcedimento.index(this.prepareData())
                .then(({ data }) => {

                    this.itens = data.procedimentos
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.form = this.clone(this.initials.form)
            this.model = this.clone(this.initials.model)

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        resetAfterPeriodo() {

            this.form = this.clone(this.initials.form)

            const model = this.clone(this.initials.model)

            delete model.periodo

            Object.keys(model).forEach(key => this.$set(this.model, key, model[key]))
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioQuantitativoProcedimento(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.columns = this.columns.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [repository, formats, error, data, object, stringCase, file],
    watch: {
        model: {
            deep: true,
            handler() {

                this.itens = []
                this.totalizadores = null
            }
        },
    }
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 400px;
}
</style>